"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _tkComponentIcons = require("@xo-union/tk-component-icons");
var _SearchBar = _interopRequireDefault(require("../SearchBar/SearchBar.js"));
var _SearchButtonModule = _interopRequireDefault(require("./SearchButton.module.css"));
var _SubNavContext = require("../../context/SubNavContext.js");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SearchButton = _ref => {
  let {
    isSearchBarRendered,
    setIsSearchBarRendered,
    onSearch,
    searchBarPlaceholder
  } = _ref;
  const {
    trackMenuInteraction
  } = (0, _react.useContext)(_SubNavContext.SubNavContext);
  const [shouldFocusSearchBar, setShouldFocusSearchBar] = (0, _react.useState)(false);
  const shouldRenderCloseIcon = isSearchBarRendered;
  const handleClick = () => {
    trackMenuInteraction === null || trackMenuInteraction === void 0 || trackMenuInteraction('search clicked');
    setIsSearchBarRendered(true);
    setShouldFocusSearchBar(true);
  };
  const handleClose = () => {
    setIsSearchBarRendered(false);
    setShouldFocusSearchBar(false);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isSearchBarRendered && /*#__PURE__*/_react.default.createElement(_SearchBar.default, {
    onSearch: onSearch,
    placeholder: searchBarPlaceholder,
    shouldFocusSearchBar: shouldFocusSearchBar
  }), !isSearchBarRendered && /*#__PURE__*/_react.default.createElement(_SearchBar.default, {
    onSearch: onSearch,
    placeholder: searchBarPlaceholder,
    handleClick: handleClick,
    shouldFocusSearchBar: shouldFocusSearchBar
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _SearchButtonModule.default.subNavIconButton__container,
    "data-testid": "SearchButton"
  }, shouldRenderCloseIcon && /*#__PURE__*/_react.default.createElement("div", {
    className: _SearchButtonModule.default.subNavIconButton__closeIcon,
    onClick: () => handleClose(),
    "data-testid": "SearchButton__closeIcon"
  }, /*#__PURE__*/_react.default.createElement(_tkComponentIcons.IconButton, {
    name: 'close',
    size: 'md',
    "aria-label": "Close Search"
  }))));
};
var _default = exports.default = SearchButton;